import { render, staticRenderFns } from "./EmailGroup.vue?vue&type=template&id=67c96ab7&scoped=true&"
import script from "./EmailGroup.vue?vue&type=script&lang=js&"
export * from "./EmailGroup.vue?vue&type=script&lang=js&"
import style0 from "./EmailGroup.vue?vue&type=style&index=0&id=67c96ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c96ab7",
  null
  
)

export default component.exports